export default __webpack_public_path__ + "static/media/ail4.29edf4f6.svg";